var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.8327C15.5228 18.8327 20 15.1018 20 10.4993C20 5.89697 15.5228 2.16602 10 2.16602C4.47715 2.16602 0 5.89697 0 10.4993C0 15.1018 4.47715 18.8327 10 18.8327Z",
    fill: "#9DE5F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15466 17.5862C1.92743 17.0316 2.47717 16.3795 2.83123 15.4395L4.76523 17.088C3.8713 18.0358 2.79421 18.6566 1.51032 18.8288C1.29801 18.8568 1.08079 18.7401 0.963088 18.5085C0.801715 18.191 0.887405 17.778 1.15466 17.5862Z",
    fill: "#9DE5F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2918 9.92808C10.592 10.4752 10.5793 10.8569 10.5793 11.5187C10.5793 11.7604 10.4521 12.0403 9.82858 12.0403C9.30683 12.0403 9.12875 11.8495 9.12875 11.1878C9.12875 10.0936 9.61225 9.57183 9.98125 9.25375C10.4012 8.89742 11.1137 8.50297 11.1137 7.8159C11.1137 7.23058 10.6047 6.95062 9.9685 6.95062C8.67058 6.95062 8.95058 7.93039 8.26344 7.93039C7.91988 7.93039 7.5 7.70137 7.5 7.20508C7.5 6.51797 8.28887 5.5 10.0067 5.5C11.6354 5.5 12.7169 6.4034 12.7169 7.59949C12.7169 8.79562 11.6354 9.66083 11.2918 9.92808ZM10.8211 13.8981C10.8211 14.4197 10.3884 14.8777 9.84133 14.8777C9.29417 14.8777 8.87425 14.4197 8.87425 13.8981C8.87425 13.3637 9.30692 12.9183 9.84133 12.9183C10.3757 12.9183 10.8211 13.3637 10.8211 13.8981Z",
    fill: "#2FA7CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructure);
export default __webpack_public_path__ + "static/media/structure.dd55345a6805a5f8cc342adbc5b7bb6d.svg";
export { ForwardRef as ReactComponent };